import React from "react";
import { testimonialType } from "../../common/types";
import { sanitizeHTML } from "../../search/utils";

export function Testimonial({ item }) {
	const { companyLogo, sourceName, sourcePositionAndCompany, quote } = item;

	return (
		<article className="quote-card typography--big">
			<div
				dangerouslySetInnerHTML={{
					__html: sanitizeHTML(quote.rawHtml),
				}}
			/>
			<div className="card-company">
				<p>
					<strong>{sourceName}</strong>
					{sourcePositionAndCompany}
				</p>
				<img src={companyLogo.url} alt={companyLogo.altText} />
			</div>
		</article>
	);
}

Testimonial.propTypes = {
	item: testimonialType.isRequired,
};
